import { KbAdminEditorSection } from "./KbAdminEditorSection";
import { KbBulkImportSection } from "./KbBulkImportSection";
import { KbChangeProposalsSection } from "./KbChangeProposalsSection";
import { KbGapInboxSection } from "./KbGapInboxSection";
import { KbLibrarySection } from "./KbLibrarySection";
import { KbNotesPanel } from "./KbNotesPanel";
import { KbTrashSection } from "./KbTrashSection";

export function KbAdminModes(p: any) {
  return (
    <>
      {p.kbMode === "library" ? (
        <KbLibrarySection
          q={p.q}
          searchAudience={p.searchAudience}
          searchScope={p.searchScope}
          searchDocType={p.searchDocType}
          searchStatus={p.searchStatus}
          results={p.results}
          selected={p.selected}
          draftCount={p.draftCount}
          draftsLoading={p.draftsLoading}
          canPublishKb={p.canPublishKb}
          publishWorking={p.publishWorking}
          deleteWorking={p.deleteWorking}
          confirmPublishSlug={p.confirmPublishSlug}
          confirmDeleteSlug={p.confirmDeleteSlug}
          onQueryChange={p.setQ}
          onSearchAudienceChange={p.setSearchAudience}
          onSearchScopeChange={p.setSearchScope}
          onSearchDocTypeChange={p.setSearchDocType}
          onSearchStatusChange={p.setSearchStatus}
          onSearch={() => { void (p.quickAuditEnabled ? p.doChunkAudit() : p.doSearch()); }}
          onResetFilters={p.resetSearchFilters}
          onLoadDrafts={() => { void p.loadDraftsIntoResults(); }}
          onLoadArticle={(slug, title) => { void p.loadArticle(slug, title); }}
          onConfirmPublish={p.setConfirmPublishSlug}
          onConfirmDelete={p.setConfirmDeleteSlug}
          onPublishDraft={(slug) => { void p.doPublishDraft(slug); }}
          onSoftDelete={(slug) => { void p.doSoftDelete(slug); }}
          onOpenEditorMode={() => p.setKbMode("editor")}
          showQuickAuditControls={p.canUseQuickChunkAudit}
          quickAuditEnabled={p.quickAuditEnabled}
          quickAuditRisk={p.quickAuditRisk}
          onQuickAuditEnabledChange={(value) => { p.setQuickAuditEnabled(value); if (!value) p.setQuickAuditRisk("all"); }}
          onQuickAuditRiskChange={p.setQuickAuditRisk}
          onRunQuickAudit={() => { void p.doChunkAudit(); }}
          showDevRescopePill={p.showDevRescopePill && !!p.onNavigateToDevKbRescope}
          devRescopeBusy={p.devRescopeBusy}
          onDevRescopeArticle={(r) => void p.devRescopeFromLibraryResult(r)}
        />
      ) : null}
      {p.kbMode === "editor" ? (
        <KbAdminEditorSection
          aiArticleLinkSuggestions={p.aiArticleLinkSuggestions}
          aiAudienceHint={p.aiAudienceHint}
          setAiAudienceHint={p.setAiAudienceHint}
          aiBodyDraft={p.aiBodyDraft}
          setAiBodyDraft={p.setAiBodyDraft}
          aiBodyGenerationNotes={p.aiBodyGenerationNotes}
          aiBusy={p.aiBusy}
          aiDocTypeHint={p.aiDocTypeHint}
          setAiDocTypeHint={p.setAiDocTypeHint}
          aiFeedback={p.aiFeedback}
          aiFollowOnDocs={p.aiFollowOnDocs}
          aiGapsOpen={p.aiGapsOpen}
          setAiGapsOpen={p.setAiGapsOpen}
          aiGeneratedNotes={p.aiGeneratedNotes}
          aiGuidance={p.aiGuidance}
          aiHelpOpen={p.aiHelpOpen}
          setAiHelpOpen={p.setAiHelpOpen}
          aiKbGapCandidates={p.aiKbGapCandidates}
          aiLinksOpen={p.aiLinksOpen}
          setAiLinksOpen={p.setAiLinksOpen}
          aiPlacementSummary={p.aiPlacementSummary}
          aiPurpose={p.aiPurpose}
          setAiPurpose={p.setAiPurpose}
          aiQuestionAnswers={p.aiQuestionAnswers}
          aiRecommendedDocCount={p.aiRecommendedDocCount}
          aiRelatedArticles={p.aiRelatedArticles}
          aiResolvedFacts={p.aiResolvedFacts}
          aiScopeHint={p.aiScopeHint}
          setAiScopeHint={p.setAiScopeHint}
          aiSourceKind={p.aiSourceKind}
          setAiSourceKind={p.setAiSourceKind}
          aiStopReason={p.aiStopReason}
          aiSuggestedAction={p.aiSuggestedAction}
          aiTopicComplexity={p.aiTopicComplexity}
          aiUpdateMetadata={p.aiUpdateMetadata}
          setAiUpdateMetadata={p.setAiUpdateMetadata}
          aiUpdateTitle={p.aiUpdateTitle}
          setAiUpdateTitle={p.setAiUpdateTitle}
          appliedSuggestion={p.appliedSuggestion}
          applyAiBodyDraft={p.applyAiBodyDraft}
          applyDictationToPurpose={p.applyDictationToPurpose}
          articleAudience={p.articleAudience}
          setArticleAudience={p.setArticleAudience}
          articleContent={p.articleContent}
          setArticleContent={p.setArticleContent}
          articleDocType={p.articleDocType}
          setArticleDocType={p.setArticleDocType}
          articleMode={p.articleMode}
          setArticleMode={p.setArticleMode}
          articleScope={p.articleScope}
          setArticleScope={p.setArticleScope}
          articleSlug={p.articleSlug}
          articleSourceUrl={p.articleSourceUrl}
          setArticleSourceUrl={p.setArticleSourceUrl}
          articleStatus={p.articleStatus}
          setArticleStatus={p.setArticleStatus}
          articleTagsInput={p.articleTagsInput}
          setArticleTagsInput={p.setArticleTagsInput}
          articleTitle={p.articleTitle}
          setArticleTitle={p.setArticleTitle}
          broaderScopeLocked={p.broaderScopeLocked}
          canManageManufacturerScope={p.canManageManufacturerScope}
          canManageAppScope={p.canManageAppScope}
          canPublishKb={p.canPublishKb}
          confirmDeleteSlug={p.confirmDeleteSlug}
          setConfirmDeleteSlug={p.setConfirmDeleteSlug}
          defaultArticleTitle={p.defaultArticleTitle}
          deleteWorking={p.deleteWorking}
          dictation={p.dictationProps}
          doArticle={() => void p.doArticle()}
          doCreateSplitStubs={() => void p.doCreateSplitStubs()}
          doProposeSplit={() => void p.doProposeSplit()}
          doSoftDelete={(slug) => void p.doSoftDelete(slug)}
          gapSaving={p.gapSaving}
          hasEditorName={p.hasEditorName}
          lastArticleId={p.lastArticleId}
          loadedArticle={p.loadedArticle}
          loadArticle={(slug, title) => void p.loadArticle(slug, title)}
          preserveOriginalBody={p.preserveOriginalBody}
          setPreserveOriginalBody={p.setPreserveOriginalBody}
          previousArticleContent={p.previousArticleContent}
          previewRelatedArticle={(slug, label) => void p.previewRelatedArticle(slug, label)}
          publishedArticleLocked={p.publishedArticleLocked}
          showDevRescopePill={p.showDevRescopePill && !!p.onNavigateToDevKbRescope && !!p.articleSlug}
          devRescopeBusy={p.devRescopeBusy}
          onDevRescopeFromEditor={() => p.devRescopeFromEditor()}
          relatedPreview={p.relatedPreview}
          setRelatedPreview={p.setRelatedPreview}
          relatedPreviewLoading={p.relatedPreviewLoading}
          clearWorkspace={p.clearWorkspace}
          resetAiSession={p.resetAiSession}
          restorePreviousBody={p.restorePreviousBody}
          runAiHelp={(mode) => void p.runAiHelp(mode)}
          saveGapsToInbox={() => void p.saveGapsToInbox()}
          setAiQuestionDisposition={p.setAiQuestionDisposition}
          setSplitOpen={p.setSplitOpen}
          setSplitProposals={p.setSplitProposals}
          showAiFeedback={p.showAiFeedback}
          splitCreating={p.splitCreating}
          splitOpen={p.splitOpen}
          splitProposals={p.splitProposals}
          splitWorking={p.splitWorking}
          updateAiQuestionAnswer={p.updateAiQuestionAnswer}
          chunkQuality={p.chunkQuality}
          chunkQualityAdvice={p.chunkQualityAdvice}
        />
      ) : null}
      {p.kbMode === "proposals" && p.canPublishKb ? <KbChangeProposalsSection editorName={p.editorName} onNote={(title, text, tone) => p.showNote({ title, text, tone })} onPendingCountChange={p.setPendingProposalCount} /> : null}
      {p.kbMode === "gap_inbox" ? <KbGapInboxSection gapInboxOpenCount={p.gapInboxOpenCount} gapInboxStatusFilter={p.gapInboxStatusFilter} gapInboxLoading={p.gapInboxLoading} gapInboxItems={p.gapInboxItems} gapInboxPage={p.gapInboxPage} gapInboxPageSize={p.gapInboxPageSize} gapInboxListTotal={p.gapInboxListTotal} gapInboxTestingOnly={p.gapInboxTestingOnly} onGapInboxTestingOnlyChange={(value) => { p.setGapInboxTestingOnly(value); p.setGapInboxPage(0); void p.refreshGapInbox(p.gapInboxStatusFilter || undefined, value, 0); }} onGapInboxStatusFilterChange={(status) => { p.setGapInboxStatusFilter(status); p.setGapInboxPage(0); void p.refreshGapInbox(status || undefined, p.gapInboxTestingOnly, 0); }} onGapInboxPageSizeChange={(size) => { p.setGapInboxPageSize(size); p.setGapInboxPage(0); void p.refreshGapInbox(p.gapInboxStatusFilter || undefined, p.gapInboxTestingOnly, 0, size); }} onGapInboxPageChange={(page) => { p.setGapInboxPage(page); void p.refreshGapInbox(p.gapInboxStatusFilter || undefined, p.gapInboxTestingOnly, page); }} onRefreshGapInbox={(status, testingOnly) => { void p.refreshGapInbox(status, testingOnly, p.gapInboxPage); }} onUpdateGapStatus={(id, status) => { void p.updateGapStatus(id, status); }} onAddressGapItem={p.addressGapItem} onPreviewRelatedArticle={(slug, label) => { void p.previewRelatedArticle(slug, label); }} onOpenRelatedArticle={(slug, label) => { void p.loadArticle(slug, label); p.setKbMode("editor"); }} onOpenSourceArticle={(slug) => { void p.loadArticle(slug, slug); p.setKbMode("editor"); }} onSuggestGapSolution={(item) => p.suggestGapSolution(item)} onResolveGapByLink={(item, slug) => p.resolveGapByLink(item, slug)} /> : null}
      {p.kbMode === "import" ? <KbBulkImportSection isBulkImporting={p.isBulkImporting} hasEditorName={p.hasEditorName} bulkImportText={p.bulkImportText} allowPolicyOverwrite={p.bulkAllowPolicyOverwrite} onAllowPolicyOverwriteChange={p.setBulkAllowPolicyOverwrite} onLoadStarterCompanyDocs={() => { void p.loadStarterCompanyDocs(p.starterUrl); }} onBulkImportTextChange={p.setBulkImportText} onBulkImport={() => { void p.doBulkImport(); }} onClearBulkImportText={() => p.setBulkImportText("")} /> : null}
      {p.kbMode === "trash" ? <KbTrashSection trashLoading={p.trashLoading} trashResults={p.trashResults} confirmPurgeSlug={p.confirmPurgeSlug} deleteWorking={p.deleteWorking} onLoadTrash={() => { void p.loadTrash(); }} onConfirmPurge={p.setConfirmPurgeSlug} onPurge={(slug) => { void p.doPurge(slug); }} /> : null}
      <KbNotesPanel note={p.note} notesOpen={p.notesOpen} onToggle={() => p.setNotesOpen((value: boolean) => !value)} />
    </>
  );
}
